export enum EnumEstadoCivil {
  solteiro = "Solteiro(a)",
  casado = "Casado(a)",
  uniao_estavel = "União estável",
  divorciado = "Divorciado(a)",
  viuvo = "Viúvo(a)"
}



// WEBPACK FOOTER //
// ./src/services/types/EnumEstadoCivil.ts